import React from 'react'
import WBPReviewImg from '../../../components/Images/WBPReview'
import { Box, Text } from '../../../designSystem'
import {
  step2Container,
  stepHeading,
  stepDesc,
  artDiv,
  okayBtn,
  hr
} from '../style'


// TODO: mention users email in the description

const Step = ({ resetSteps }) => (
  <>
    <Box {...step2Container}>
      <Box>
        <Text  {...stepHeading}>Your Application is being reviewed</Text>
      </Box>
      <Box >
      <Text {...stepDesc}>Thank you for applying to the Writer Benefits Program. We have received your application and it is being reviewed. You will receive a notification on your email.
        In the meantime keep adding new chapters to your novel for your readers.</Text>
      </Box>
      <Box {...artDiv}>
        <WBPReviewImg />
      </Box>
      <Box {...hr} />
      <Box {...okayBtn} onClick={resetSteps} >Okay</Box>
    </Box>
  </>
)
export default Step
